// import React from 'react';
import { usePreload } from './hooks/usePreload';

export let ImagePreloader = ({ url, children }) => {
  usePreload(url);
  return children || null;
};
